import { lazy } from 'react';

import type { AppRouteConfig } from '@/App/AppRoutes/types';

const TokenInvalidPage = lazy(() =>
  import('@/components/pages/TokenInvalidPage').then(({ TokenInvalidPage }) => ({ default: TokenInvalidPage })),
);

export const TokenInvalidRoute: AppRouteConfig = {
  key: 'token-invalid-page',
  path: '/token_invalid/:locale?',
  component: TokenInvalidPage,
};
